import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { getProductSizeValues } from '../../utils/sizeOptions';

const selectCartItems = (state: RootState) => state.shoppingCart.cartItems;

export const selectedSizeCart = createSelector(
  [selectCartItems],
  (cartItems) => cartItems.map((item) => {
    const sizes = getProductSizeValues(
      item.product.sizes,
      item.product.materialPrices,
      item.selectedMaterial
    );

    return {
      id: item.id,
      selectedSize: item.selectedSize,
      sizes,
      sizeErrors: item.sizeErrors || [],
    };
  })
);

export const selectSizeProduct = createSelector(
    [
      (state: RootState) => state.curProduct.productId,
      (state: RootState) => state.curProduct.selectedSize,
      (state: RootState) => state.curProduct.selectedMaterial,
    ],
    (product, selectedSize, selectedMaterial) => {
      if (!product) {
        return {
          selectedSize: '',
          sizesArray: [],
          productId: '',
        };
      }
  
      const sizesArray = getProductSizeValues(
        product.sizes,
        product.materialPrices,
        selectedMaterial
      );
  
      return {
        selectedSize: selectedSize || '',
        sizesArray,
        productId: product.id || '',
      };
    }
  );

export const selectSelectedSize = (state: RootState) => state.curProduct.selectedSize || '';

